// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CwYb","type":"styles_type__2lOtJ","choices":"styles_choices__1zjAp"};